var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.998,
    height: 47.999,
    viewBox: "0 0 47.998 47.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ANSRLogos_Rise01_24x24",
    "data-name": "ANSRLogos_Rise01 24x24",
    transform: "translate(-91.498 -56.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13989",
    "data-name": "Group 13989",
    transform: "translate(97.418 56.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11271",
    "data-name": "Path 11271",
    d: "M161.137,56.5q.242,0,.159.211a13.651,13.651,0,0,0-1.268,1.586,9.362,9.362,0,0,1-7.558,6.078q-2.484.106-4.968,0A24.026,24.026,0,0,1,161.137,56.5Z",
    transform: "translate(-147.5 -56.5)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.963
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13990",
    "data-name": "Group 13990",
    transform: "translate(92.873 56.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11272",
    "data-name": "Path 11272",
    d: "M129.976,56.5a21.178,21.178,0,0,1,12.685,5.338l-12.262.106a9.183,9.183,0,0,0-6.4,3.647,29.083,29.083,0,0,1-2.114,3.488A9.3,9.3,0,0,1,115.6,72.3q-5.549.079-11.1.053a20.957,20.957,0,0,1,2.537-5.391q4.545-.132,9.091-.159a9.274,9.274,0,0,0,6.4-4.176A9.617,9.617,0,0,1,129.976,56.5Z",
    transform: "translate(-104.5 -56.5)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.973
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13991",
    "data-name": "Group 13991",
    transform: "translate(91.498 64.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11273",
    "data-name": "Path 11273",
    d: "M120.886,130.444q6.4-.027,12.791.053a24.538,24.538,0,0,1,3.488,5.338q-8.673.083-17.337.264a8.984,8.984,0,0,0-5.444,3.541,29.086,29.086,0,0,1-2.114,3.488,9.547,9.547,0,0,1-5.761,3.118Q99,146.327,91.5,146.3a21.932,21.932,0,0,1,.634-5.338l13.954-.106a9.192,9.192,0,0,0,6.818-4.176A9.562,9.562,0,0,1,120.886,130.444Z",
    transform: "translate(-91.498 -130.437)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.979
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13992",
    "data-name": "Group 13992",
    transform: "translate(91.604 72.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11274",
    "data-name": "Path 11274",
    d: "M123.367,205.444q7.876-.027,15.751.053a20.648,20.648,0,0,1,1.163,5.338q-8.246-.027-16.491.053a9.269,9.269,0,0,0-6.5,3.753,29.085,29.085,0,0,1-2.114,3.488,9.3,9.3,0,0,1-6.078,3.118q-7.717.079-15.434.053a35.741,35.741,0,0,1-1.163-5.286q7.875-.132,15.751-.159a9.189,9.189,0,0,0,7.558-4.176A9.9,9.9,0,0,1,123.367,205.444Z",
    transform: "translate(-92.5 -205.437)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.983
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13993",
    "data-name": "Group 13993",
    transform: "translate(93.93 80.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11275",
    "data-name": "Path 11275",
    d: "M145.685,279.5h14.377a23.406,23.406,0,0,1-.529,5.5q-7.189-.026-14.377.053a9.153,9.153,0,0,0-6.4,4.07,10.465,10.465,0,0,1-3.964,4.916,9.455,9.455,0,0,1-3.488,1.268q-6.713.106-13.425,0a20.145,20.145,0,0,1-3.383-5.338q8.193.027,16.385-.053a8.951,8.951,0,0,0,6.078-3.33,22.1,22.1,0,0,0,1.8-3.066A9.7,9.7,0,0,1,145.685,279.5Z",
    transform: "translate(-114.5 -279.5)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.977
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13994",
    "data-name": "Group 13994",
    transform: "translate(99.955 88.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11276",
    "data-name": "Path 11276",
    d: "M198.245,354.388q5.762-.053,11.522.106a21.477,21.477,0,0,1-2.643,5.233l-8.457.106a9.182,9.182,0,0,0-6.924,4.176,10.264,10.264,0,0,1-3.858,4.81,9.383,9.383,0,0,1-4.493,1.427,23.4,23.4,0,0,1-11.892-5.338l11.84-.106a9.291,9.291,0,0,0,6.607-3.33q1.084-1.639,2.008-3.383A9.577,9.577,0,0,1,198.245,354.388Z",
    transform: "translate(-171.5 -354.375)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.98
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13995",
    "data-name": "Group 13995",
    transform: "translate(119.723 96.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11277",
    "data-name": "Path 11277",
    d: "M368.225,428.444q2.115-.026,4.228.053a22.524,22.524,0,0,1-13.954,7.823,10.665,10.665,0,0,0,1.427-1.744A9.444,9.444,0,0,1,368.225,428.444Z",
    transform: "translate(-358.5 -428.437)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.96
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon);
export default __webpack_public_path__ + "static/media/Logoicon.0cbf731c6c90ced3c4bdda815b2aea36.svg";
export { ForwardRef as ReactComponent };